import { translate } from "app/filters/i18nFilter";
import NewAssetIconButtonTracked from "app/pages/sales-intelligence/pages/home/containers/NewAssetButton/NewAssetIconButtonTracked";
import TutorialViewTracked from "app/pages/sales-intelligence/pages/home/containers/TutorialView/TutorialViewTracked";
import { toggleOpportunityListModal } from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import { useIsFetching } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { StyledButtonsContainer } from "../../components/styles";
import { homePageQueryKeys } from "../../services/queries/queryKeyFactory";
import type { ViewModelMetadata } from "../../types/models";
import { PlainTooltip } from "@similarweb/ui-components";
import { MAX_WATCH_LIST_TOOLTIP_WIDTH } from "app/pages/sales-intelligence/pages/home/utils/const";

type Props = {
    metadata: ViewModelMetadata;
};

const ListsCardActionsContainer = ({ metadata }: Props) => {
    const dispatch = useDispatch();

    const fetchingQueriesCount = useIsFetching({ queryKey: homePageQueryKeys.lists() });
    const isActionDisabled = fetchingQueriesCount > 0;

    const handleAddClick = () => {
        dispatch(toggleOpportunityListModal(true));
    };

    return (
        <StyledButtonsContainer>
            <NewAssetIconButtonTracked
                isDisabled={isActionDisabled}
                metadata={metadata}
                onClick={handleAddClick}
            >
                {translate("si.pages.home.card.lists.action.add")}
            </NewAssetIconButtonTracked>
            <PlainTooltip
                tooltipContent={translate("si.pages.home.card.tooltip.watch_tutorial")}
                placement="top"
                maxWidth={MAX_WATCH_LIST_TOOLTIP_WIDTH}
            >
                <div>
                    <TutorialViewTracked
                        metadata={metadata}
                        stateId="salesIntelligence-home-myLists"
                        isDisabled={isActionDisabled}
                    />
                </div>
            </PlainTooltip>
        </StyledButtonsContainer>
    );
};

export default ListsCardActionsContainer;
